import { Component, Input, OnInit } from '@angular/core';
import { ProductsService } from '../../../_services/products/products.service';
import { SessionService } from '../../../_services/session/session.service';
import { BaseComponent } from '../../base/base.component';
import IProduct from '../../../_interfaces/IProduct';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'app-selector-site-products',
  templateUrl: './selector-site-products.component.html',
  styleUrls: ['./selector-site-products.component.scss'],
  imports: [SelectModule, FormsModule, TranslatePipe],
})
export class SelectorSiteProductsComponent
  extends BaseComponent
  implements OnInit
{
  @Input('placeholder') public placeholder: string;
  @Input('onSelect') public onSelect: (IProduct) => void = () => undefined;
  public products: IProduct[];

  @Input('selected')
  public selected: IProduct;

  constructor(
    public session: SessionService,
    public productsService: ProductsService
  ) {
    super(session);
  }

  clear() {
    this.selected = undefined;
    this.onSelect(this.selected);
  }

  loadProducts() {
    this.productsService
      .getByCustomerAndSite(this.customers_id, this.sites_id)
      .subscribe((products) => {
        this.products = products.map((product) => ({
          ...product,
          name: this.display(product),
        }));

        this.products = products.sort((a, b) =>
          a.category.name.localeCompare(b.category.name)
        );

        if (this.selected) {
          this.selected = this.products.find(
            (product) => product.products_id === this.selected.id
          );
          this.onSelect(this.selected);
        }
      });
  }

  display(option: IProduct) {
    return `${option.category.name} / ${option.name}`;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.loadProducts();
  }
}
